import Overlay from 'sbf-design-system-component/overlays/overlay';
import banner from 'sbf-design-system-component/banners/banner';
import 'sbf-design-system-component/forms/base';
import 'sbf-design-system/js/lib/parsley';
import lazySizes from 'lazysizes'; // small library to lazyload below the fold images/vid

lazySizes.cfg.iframeLoadMode = 1;

// Open Privacy Policy Overlay
const $privacyPolicyTrigger = $('#pp_overlay_trigger');

new Overlay($('#privacy-policy_overlay'), { // eslint-disable-line no-new
  full_screen: true,
  triggers: [$privacyPolicyTrigger]
});

/**
 * Form submit button click.
 *
 * @param    object    e     An event object.
 * @return   none
 */
$('#battle-event-application-form').find('.button').on('click', function (e) {
  // If in page edit mode.
  if (window.sbf.ce && window.sbf.ce.init) {
    return;
  }
  // Form field validation check.
  if (!validateFields()) {
    return;
  }
  // If recaptcha is enabled.
  if (typeof window.grecaptcha !== 'undefined' && window.grecaptcha) {
    // This console message is intentional to allow devs to see if the invisible recaptcha is loaded.
    console.info('Recaptcha enabled');
    // Execute recaptcha check.
    window.grecaptcha.execute();
  } else {
    postEventApplication();
  }
});

/**
 * Form submission event.
 *
 * @param    object    e     An event object.
 * @return   none
 */
$('#battle-event-application-form').on('submit', function (e) {
  // Custom handling used so never allow the default submit action.
  e.preventDefault();
});

/**
 * Validate form field values.
 *
 * @return   bool
 */
function validateFields () {
  const $field = $('.inline-input');
  let returnValue = true;

  $field.find('[required]').each(function () {
    // generic field validation as defined in markup
    if (!validateField(this)) {
      banner.showError($(this).attr('data-parsley-error-message'), true, 4000);
      if (typeof window.grecaptcha !== 'undefined' && window.grecaptcha) {
        window.grecaptcha.reset();
      }
      if (!window.navigator.userAgent.match(/iPhone/i)) {
        this.focus();
      }

      $(this).addClass('field--invalid');

      returnValue = false;
      return false; // stop looping
    }
  });

  return returnValue;
}

/**
 * Validate a single form field value.
 *
 * @param    object    el    An html element.
 * @return   bool
 */
function validateField (el) {
  let valid = true;

  // special field checks first
  if (el.name === 'phone') {
    if (!validatePhoneNumber(el.value)) {
      valid = false;
    }
  }

  if (!valid || !$(el).parsley().isValid(true)) {
    return false;
  }
  return true;
}

/**
 * Validate a phone number value.
 *
 * @param    string    mightBeAPhoneNumber    A phone number string.
 * @return   bool
 */
function validatePhoneNumber (mightBeAPhoneNumber) {
  // strip anything that's not a digit and make sure there are 10 or more of what's left
  const onlyNumbers = mightBeAPhoneNumber.replace(/[^0-9]/g, '');
  // not requiring area code currently
  return onlyNumbers.length >= 7;
}

/**
 * Send event application data to the server.
 *
 * @return   none
 */
function postEventApplication () {
  const data = $('#battle-event-application-form').serialize();
  const $submitButton = $('#frontend-battle-submit .button');
  let url = `https://${window.location.host}`;
  url += '/battle/event-application.json';

  $.ajax({
    type: 'post',
    dataType: 'json',
    data,
    url,
    beforeSend: function (xhr) {
      banner.showSaving('Processing your event application...', false, false);
      $submitButton.hide();
    },
    success: function () {
      $('#battle-form').hide();
      $('#battle-thankyou').show();
      window.location.href = '#battle-thankyou';
      banner.close();
    },
    error: function (xhr) {
      banner.showError('Unable to process this event application.', true);
      if (typeof window.grecaptcha !== 'undefined' && window.grecaptcha) {
        window.grecaptcha.reset();
      }
      $submitButton.show();
    },
    complete: function (xhr) {}
  });
}

/**
 * Handle recaptcha response.
 *
 * @return   none
 */
window.captchaCallback = function (token) {
  // If recaptcha token is valid.
  if (token.length !== 0) {
    postEventApplication();
  } else if (window.grecaptcha) {
    banner.showError('An recaptcha error has occurred.', true);
    window.grecaptcha.reset();
  }
};
